import { Badge } from "@/components/ui/badge";
import { KELOMPOK_KEPNAKES, LABEL_KELOMPOK } from "@/lib/survei";

// Lencana kelompok periode survei (Kedokteran / Kepnakes) di daftar periode & tab Tautan.
export default function SurveiBadgeKelompok({ kelompok, testId }) {
    const kepnakes = kelompok === KELOMPOK_KEPNAKES;
    return (
        <Badge variant="outline" data-testid={testId}
               className={kepnakes ? "border-violet-300 bg-violet-50 text-violet-800" : "border-teal-300 bg-teal-50 text-teal-800"}>
            {LABEL_KELOMPOK[kepnakes ? KELOMPOK_KEPNAKES : "kedokteran"]}
        </Badge>
    );
}
